import { IconClose } from "@douyinfe/semi-icons";
import styles from "./index.module.scss";

interface Prop {
  close: () => void;
}

const ProgressBar: React.FC<Prop> = ({ close }) => {
  return (
    <div className={styles.container}>
      <IconClose className={styles.icon} onClick={close} />
      <span>
        Downloading...
        {/* {fileStatus && (
          <>
            [{fileStatus.loaded}/{fileStatus.total}]
          </>
        )} */}
      </span>
    </div>
  );
};

export default ProgressBar;
